import { render, staticRenderFns } from "./BarTextVis.vue?vue&type=template&id=3567e93c&scoped=true&"
import script from "./BarTextVis.vue?vue&type=script&lang=js&"
export * from "./BarTextVis.vue?vue&type=script&lang=js&"
import style0 from "./BarTextVis.vue?vue&type=style&index=0&id=3567e93c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3567e93c",
  null
  
)

export default component.exports